import React from "react";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-gls-deep text-slate-300 relative grain">
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <img
              src={COMPANY.logo}
              alt="GLS"
              className="h-16 w-auto object-contain [filter:drop-shadow(0_0_10px_rgba(255,255,255,0.5))_brightness(1.1)]"
            />
            <p className="mt-5 text-sm leading-relaxed text-slate-400">
              {COMPANY.legal} — {t.footer.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">{t.footer.navigation}</h4>
            <ul className="space-y-2.5">
              {t.nav.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm hover:text-gls-red transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">{t.footer.services}</h4>
            <ul className="space-y-2.5">
              {t.services.items.slice(0, 5).map((s) => (
                <li key={s.title} className="text-sm text-slate-400">{s.title}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">{t.footer.contact}</h4>
            <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-2 text-sm hover:text-gls-red transition-colors mb-3">
              <Phone size={16} /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 text-sm hover:text-gls-red transition-colors">
              <Mail size={16} /> {COMPANY.email}
            </a>
            <div className="flex items-start gap-2 text-sm text-slate-400 mt-3">
              <MapPin size={16} className="mt-0.5 shrink-0" /> {COMPANY.address}
            </div>
            <div className="flex items-start gap-2 text-sm text-slate-400 mt-2">
              <MapPin size={16} className="mt-0.5 shrink-0" /> {COMPANY.addressKinshasa}
            </div>
            <a href="#contact" className="mt-5 inline-flex items-center gap-1.5 bg-gls-red text-white px-5 py-2.5 rounded-full text-sm font-bold hover:bg-white hover:text-gls-navy transition-colors">
              {t.cta} <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {COMPANY.legal}. {t.footer.rights}</p>
          <a
            href="https://edeinet.ca"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gls-red transition-colors"
            data-testid="footer-powered-by"
          >
            Powered by Edeinet
          </a>
        </div>
      </div>
    </footer>
  );
}
